import Constants from '@/apis/api-urls/constants'

export default {
  data () {
    return {
      isTest: process.env.ENV === 'test',
      inApp: !!window.navigator.userAgent.match(/vsnapp/gi) || !!process.env.APP,
      os: window.navigator.userAgent.match(/ios|iphone|ipad/gi)
        ? 'ios'
        : window.navigator.userAgent.match(/android/gi)
          ? 'android'
          : 'other',
      isWechat: /MicroMessenger/i.test(navigator.userAgent),
      isPC: !(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
    }
  },
  methods: {
    sensorClick (eventname, sensor, ...rest) {
      let s = {}
      rest.slice(0).forEach(item => {
        s[item] = sensor[item]
      })
      this.$sa.click({
        eventname: eventname,
        ...s
      })
    },
    sensorPageView (title, sensor, ...rest) {
      let s = {}
      rest.slice(0).forEach(item => {
        s[item] = sensor[item]
      })
      this.$sa.pageview(title, {
        ...s
      })
    },
    searchFormat (search) {
      let searchObj = {}
      search.slice(1).split('&').forEach(item => {
        let ar = item.split('=')
        searchObj[ar[0]] = ar[1]
      })
      return searchObj
    },
    linkSlice (link, prop, value) {
      let pre = link ? '&' : '?'
      return link + pre + prop + '=' + value
    },
    sensorH5Click (eventname, sensor, ...rest) {
      let s = {}
      rest.slice(0).forEach(item => {
        s[item] = sensor[item]
      })
      this.$sa.h5click({
        eventname: eventname,
        ...s
      })
    },
    apiUrlDeal (apiName, ...params) {
      let apis = Constants[apiName].split(' ')
      let type = apis[0]
      const urlSplit = apis[1].split(/:[^/]+/)

      let url = ''

      params = params.slice(0)

      urlSplit.forEach((item, index) => {
        let param = params[index] || ''
        url = url + item + param
      })
      return {
        type: type,
        url: url
      }
    },
    stringToLink (link) {
      let aLink = window.document.createElement('a')
      aLink.href = link
      return aLink
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/global.js